import { Button } from 'opensolar-ui'
import { useFileUploadContext } from '../controller/UploadFileContext'

type UploadButtonProps = {
  label: string
  disabled?: boolean
  onSuccess?: (uploadedFiles: any[]) => void
  onError?: (error: Error) => void
}

export const UploadButton = ({ label, disabled, onSuccess, onError }: UploadButtonProps) => {
  const { uploadAll } = useFileUploadContext()
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={async () => {
        try {
          const uploadedFiles = await uploadAll()
          onSuccess?.(uploadedFiles)
        } catch (error) {
          const err = error instanceof Error ? error : new Error(String(error))
          onError?.(err)
          // Also log to console if no error handler provided
          if (!onError) {
            console.error('Upload failed:', error)
          }
        }
      }}
      disabled={disabled}
    >
      {label}
    </Button>
  )
}
